export default __webpack_public_path__ + "static/media/imageearphones.6e8830d4.png";